import { useEffect, useState } from 'react';

import { NewsEvent } from '@/modules/calendar/model/calendar/news-event';
import { Article, ArticleList, articleApi } from '@/modules/articles/export';
import { DataTopic } from '@/modules/calendar/model/data/data-topic';
import { metadataMappingService } from '@/shared/util/export';

export default function RelatedArticles({
  event,
  onArticleClick,
}: {
  event: NewsEvent;
  onArticleClick: (article: Article) => void;
}) {
  const [relatedArticles, setRelatedArticles] = useState<Article[]>();

  useEffect(() => {
    const topics: { [key: string]: DataTopic } = {};

    event.dataRelease?.series.forEach(value => {
      value.topics.forEach(topic => {
        topics[topic.qcode] = topic;
      });
    });
    const sections = metadataMappingService.getConceptItemsFromDataTopics(
      Object.values(topics).map(value => value.qcode),
    );
    if (!relatedArticles || relatedArticles?.length === 0) {
      articleApi
        .getArticlesByIntersection({
          include: sections.subjects,
          keywords: sections.keywords,
          teasers: true,
        })
        .then(page => {
          setRelatedArticles(page.content);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ArticleList
      id={`related-articles-${event.id}`}
      articles={relatedArticles}
      onArticleClick={onArticleClick}
      colorizeDates={true}
      showGenreTags={false}
    />
  );
}
